import React, { useEffect, useRef } from 'react'
import classNames from 'classnames'
import { VidyardVideoPlayerProps } from './VidyardVideo.d'

const VidyardVideoPlayer = ({
  vidyardId,
  display = 'lightbox',
  classes = '',
  disableAnalytics = '0'
}: VidyardVideoPlayerProps) => {
  const ref = useRef<any | null>(null)
  useEffect(() => {
    if (typeof window !== 'undefined' && vidyardId) {
      ;(async () => {
        // @ts-ignore - Typescript defs missing for @vidyard/embed-code
        const vidyardEmbed = await import('@vidyard/embed-code')
        if (vidyardEmbed.api && ref.current) {
          vidyardEmbed.api.renderDOMPlayers(ref.current)
        }
      })()
    }
  }, [])

  const vidyardClasses = classNames(classes, {
    'relative mt-5 mb-12 flex flex-wrap w-full':
      classes === '' && display === 'lightbox',
    'h-full w-full relative': classes === '' && display === 'inline'
  })

  return (
    <>
      {display === 'lightbox' && (
        <div
          className={vidyardClasses}
          data-testid='vidyard-video-player'
          ref={ref}
        >
          <div className='mx-auto w-full overflow-hidden block h-auto relative text-center max-w-full'>
            <img
              alt={`Vidyard Video ${vidyardId}`}
              className='vidyard-player-embed w-full m-auto block'
              data-autoplay='1'
              data-type='lightbox'
              data-uuid={vidyardId}
              data-v='4'
              loading='lazy'
            />
          </div>
        </div>
      )}
      {display === 'inline' && (
        <div
          className={vidyardClasses}
          data-testid='vidyard-video-player'
          ref={ref}
        >
          <img
            alt={`Vidyard Video ${vidyardId}`}
            className='vidyard-player-embed w-full m-auto hidden'
            data-disable_analytics={disableAnalytics}
            data-type='inline'
            data-uuid={vidyardId}
            data-v='4'
            loading='lazy'
          />
        </div>
      )}
    </>
  )
}

export default VidyardVideoPlayer
